export const events = [
  {
    id: "fanwei-storm",
    title: "春日档古装剧番位风波：从海报排序到联合声明的完整复盘",
    category: "影视剧集",
    tag: "持续发酵",
    heat: 9860,
    time: "2026-09-11",
    videoLength: 0,
    summary:
      "一部未播先火的古装剧，因为宣传海报上演员的站位与字号大小，引发了持续两周的番位讨论。剧组随后发布联合声明回应，事件从「海报细节」升级为对整部剧宣传策略的公开复盘。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20crimson%20and%20amber%20abstract%20stage%20with%20soft%20spotlight%20and%20film%20grain%2C%20cinematic%20entertainment%20magazine%20editorial%20background%2C%20no%20text&width=900&height=640&seq=gua-ev-01&orientation=landscape",
  },
  {
    id: "ticket-war",
    title: "音乐节门票开售秒空：黄牛、手速党与退票规则的三方博弈",
    category: "音乐现场",
    tag: "高热",
    heat: 8720,
    time: "2026-09-10",
    videoLength: 0,
    summary:
      "热门音乐节门票在开售后数分钟内售罄，随之而来的是关于抢票工具、实名退票与场地容纳量的讨论。我们梳理了这场「抢票攻防战」的完整时间线，以及主办方给出的应对方案。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20concert%20crowd%20silhouette%20in%20warm%20amber%20and%20red%20light%2C%20blurred%20stage%20glow%2C%20editorial%20music%20festival%20atmosphere%2C%20no%20text&width=900&height=640&seq=gua-ev-02&orientation=landscape",
  },
  {
    id: "editing-dispute",
    title: "旅行真人秀「名场面」是怎么剪出来的：一次综艺剪辑争议",
    category: "综艺前线",
    tag: "争议",
    heat: 7990,
    time: "2026-09-09",
    videoLength: 0,
    summary:
      "一档旅行真人秀因为正片剪辑顺序与未播花絮的差异，被观众质疑「人设塑造」。争议的核心并不在嘉宾，而在于节目组对叙事节奏的选择。本文拆解了三个被讨论最多的片段。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20film%20editing%20timeline%20with%20warm%20amber%20frames%20and%20soft%20grain%2C%20cinematic%20light%20leaks%2C%20editorial%20background%2C%20no%20text&width=900&height=640&seq=gua-ev-03&orientation=landscape",
  },
  {
    id: "concert-reschedule",
    title: "演唱会临时改档：主办方、场馆与粉丝之间的三方拉扯",
    category: "音乐现场",
    tag: "进展中",
    heat: 7410,
    time: "2026-09-08",
    videoLength: 0,
    summary:
      "临近开演前一周，一场巡演官宣调整档期，随之而来的是机票酒店改签、退票补偿与场馆档期的连锁问题。事件暴露了巡演排期与城市场馆资源之间的现实矛盾。",
    image:
      "https://readdy.ai/api/search-image?query=empty%20concert%20hall%20seats%20in%20warm%20amber%20light%20with%20soft%20grain%2C%20abstract%20editorial%20atmosphere%2C%20muted%20crimson%20tones%2C%20no%20text&width=900&height=640&seq=gua-ev-04&orientation=landscape",
  },
  {
    id: "merch-misfire",
    title: "限定周边设计翻车：一次高风险品牌联名的完整复盘",
    category: "品牌联名",
    tag: "复盘",
    heat: 6880,
    time: "2026-09-07",
    videoLength: 0,
    summary:
      "某品牌与热门 IP 的限定周边上线后，因设计还原度与定价问题引发讨论。从打样到售罄，这次联名几乎踩中了周边开发的所有常见雷区。我们按环节梳理了问题出在哪一步。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20product%20packaging%20boxes%20in%20warm%20cream%20and%20amber%20tones%2C%20soft%20studio%20lighting%2C%20editorial%20merchandise%20flat%20lay%2C%20no%20text&width=900&height=640&seq=gua-ev-05&orientation=landscape",
  },
  {
    id: "short-drama-global",
    title: "短剧出海热：从竖屏爆款到海外分账的一门生意经",
    category: "短剧出海",
    tag: "行业观察",
    heat: 6320,
    time: "2026-09-06",
    videoLength: 0,
    summary:
      "竖屏短剧在海外市场的分账模式逐渐成熟，题材本地化与投流成本成为决定收益的关键。本文整理了几个已被验证的出海路径，以及它们各自的成本结构。",
    image:
      "https://readdy.ai/api/search-image?query=vertical%20phone%20screen%20abstract%20frames%20in%20warm%20amber%20and%20deep%20red%2C%20minimal%20studio%20background%2C%20editorial%20digital%20media%20concept%2C%20no%20text&width=900&height=640&seq=gua-ev-06&orientation=landscape",
  },
  {
    id: "actor-director",
    title: "演员转型导演：口碑两极分化背后的创作逻辑",
    category: "影视剧集",
    tag: "深度",
    heat: 5940,
    time: "2026-09-05",
    videoLength: 0,
    summary:
      "越来越多的演员开始尝试执导长片，但市场反馈常常两极。表演经验能否迁移到导演岗位？我们对比了三个转型案例在叙事、节奏与制片控制上的差异。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20director%20chair%20silhouette%20on%20warm%20amber%20film%20set%20with%20soft%20grain%2C%20cinematic%20editorial%20background%2C%20no%20text&width=900&height=640&seq=gua-ev-07&orientation=landscape",
  },
  {
    id: "seat-map",
    title: "颁奖礼座位图玄学：一张图看懂圈内咖位排序",
    category: "明星动态",
    tag: "轻松向",
    heat: 5510,
    time: "2026-09-04",
    videoLength: 0,
    summary:
      "每年颁奖礼的座位安排都会成为讨论焦点。座位图看似随机，其实和提名、资历、宣传档期都有关系。本文用一张示意图拆解了排版背后的几条潜规则。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20award%20ceremony%20stage%20with%20golden%20warm%20light%20and%20rows%20of%20seats%2C%20editorial%20cinematic%20grain%2C%20no%20text&width=900&height=640&seq=gua-ev-08&orientation=landscape",
  },
];